import { useState } from 'react'
import { trackInternalEvent } from '@rio/tracking'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { Icon20 } from 'builder/components/Icon'

import { CategoryIds } from '../CategoryTabs'
import { useGetProgress } from './hooks/useGetProgress'
import useProgressTrackerTab from './hooks/useProgressTrackerTab'

import PtMobile from './PtMobile'
import PtDesktop from './PtDesktop'
import { ProgressModal } from './ProgressModal/ProgressModal'

import { ExpandButton, PTContainer } from './styles'

export const ProgressTracker = ({ categoryId }: { categoryId: CategoryIds }) => {
  const { isDesktop, isPhone, isTablet, isLaptop } = useMediaQueries()
  const { data: progressData, isFetching } = useGetProgress()
  const { data, activeServiceId, setActiveServiceId, selectedService } = useProgressTrackerTab(
    categoryId,
    progressData,
  )
  const [openProgressModal, setOpenProgressModal] = useState(false)

  const handleOpenProgressModal = () => {
    trackInternalEvent('progress_scores_expand')
    setOpenProgressModal(!openProgressModal)
  }

  const ProgressModalTrigger = (
    <ExpandButton onClick={handleOpenProgressModal}>
      <Icon20.ExpandNew />
    </ExpandButton>
  )

  return (
    <PTContainer id="dashboard-progress-tracker">
      {isDesktop && (
        <PtDesktop
          data={data}
          setActiveServiceId={(id: string) => {
            setActiveServiceId(id)
            localStorage.setItem(`lastServiceId:${categoryId}`, id)
          }}
          activeServiceId={activeServiceId}
          isFetching={isFetching}
          selectedService={selectedService}
          ProgressModalTrigger={ProgressModalTrigger}
          categoryId={categoryId}
        />
      )}

      {(isPhone || isTablet || isLaptop) && (
        <PtMobile
          data={data}
          setActiveServiceId={(id: string) => {
            setActiveServiceId(id)
            localStorage.setItem(`lastServiceId:${categoryId}`, id)
          }}
          activeServiceId={activeServiceId}
          isFetching={isFetching}
          ProgressModalTrigger={ProgressModalTrigger}
          categoryId={categoryId}
        />
      )}

      <ProgressModal
        onClose={() => setOpenProgressModal(false)}
        progressData={progressData}
        isOpen={openProgressModal}
      />
    </PTContainer>
  )
}
